// class DetailsModal extends HTMLElement {
//   constructor() {
//     super();
//     this.detailsContainer = this.querySelector('details');
//     this.summaryToggle = this.querySelector('summary');

//     this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
//     this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
//     this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

//     this.summaryToggle.setAttribute('role', 'button');
//   }

//   isOpen() {
//     return this.detailsContainer.hasAttribute('open');
//   }

//   onSummaryClick(event) {
//     event.preventDefault();
//     event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
//   }

//   onBodyClick(event) {
//     if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
//   }

//   open(event) {
//     this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
//     event.target.closest('details').setAttribute('open', true);
//     document.body.addEventListener('click', this.onBodyClickEvent);
//     document.body.classList.add('overflow-hidden');

//     trapFocus(
//       this.detailsContainer.querySelector('[tabindex="-1"]'),
//       this.detailsContainer.querySelector('input:not([type="hidden"])')
//     );
//   }

//   close(focusToggle = true) {
//     removeTrapFocus(focusToggle ? this.summaryToggle : null);
//     this.detailsContainer.removeAttribute('open');
//     document.body.removeEventListener('click', this.onBodyClickEvent);
//     document.body.classList.remove('overflow-hidden');
//   }
// }

// customElements.define('details-modal', DetailsModal);



class DetailsModal extends HTMLElement {
  constructor() {
    super();

    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.closeButton = this.querySelector('.search-modal__close-button');

    if (!this.detailsContainer || !this.summaryToggle) return;

    // Bind once so we can add/remove properly
    this.onBodyClickEvent = this.onBodyClick.bind(this);

    // ESC key closes
    this.detailsContainer.addEventListener('keyup', (event) => {
      const key = event.key || event.code;
      if (key && key.toLowerCase() === 'escape') {
        this.close();
      }
    });

    // Click on search icon / text
    this.summaryToggle.addEventListener('click', (event) => this.onSummaryClick(event));

    // Click on X button
    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => this.close());
    }

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.stopPropagation(); // avoid body click firing immediately

    if (this.isOpen()) {
      this.close();
    } else {
      this.open();
    }
  }

  onBodyClick(event) {
    const clickedInside = this.contains(event.target);
    const clickedOverlay = event.target.classList.contains('modal-overlay');

    // If click is outside the component OR on the overlay → close
    if (!clickedInside || clickedOverlay) {
      this.close(false);
    }
  }

  open() {
    this.detailsContainer.setAttribute('open', true);

    // 🔹 Listen for outside clicks
    document.body.addEventListener('click', this.onBodyClickEvent);

    // 🔹 No scroll lock:
    // document.body.classList.add('overflow-hidden');

    if (typeof trapFocus === 'function') {
      trapFocus(
        this.detailsContainer.querySelector('[tabindex="-1"]'),
        this.detailsContainer.querySelector('input:not([type="hidden"])')
      );
    }
  }

  close(focusToggle = true) {
    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(focusToggle ? this.summaryToggle : null);
    }

    this.detailsContainer.removeAttribute('open');

    // 🔹 Stop listening for outside clicks
    document.body.removeEventListener('click', this.onBodyClickEvent);

    // 🔹 No scroll unlock needed:
    // document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);